export default __webpack_public_path__ + "static/media/Ballroll_00180.ad3b3ebf.png";